"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoService = void 0;
class PromoService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Spot Prizes Winners
     * @returns SpotPrizesResponse Successful Response
     * @throws ApiError
     */
    chathostSpotPrizesWinners() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/promo/luckychats',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Anniversary
     * @returns AnniversaryResponse Successful Response
     * @throws ApiError
     */
    chathostAnniversary() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/promo/anniversary',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Valentines
     * @returns ValentinesResponse Successful Response
     * @throws ApiError
     */
    chathostValentines() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/promo/valentines',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Valentines Join Update
     * @param requestBody
     * @returns ValentinesJoinUpdateResponse Successful Response
     * @throws ApiError
     */
    chathostValentinesJoinUpdate(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/promo/valentines',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
}
exports.PromoService = PromoService;
